import { ChangeDetectionStrategy,Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatChip, MatChipListbox, MatChipOption, MatChipRemove, MatChipSet } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

import { Auth0User } from 'app/shared/graph/schema-dotnet';

@Component({
    selector: 'admin-users-role-management',
    templateUrl: './users-roles-management.component.html',
    styleUrls: ['./users-roles-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, MatChipRemove, MatIcon, MatButton, MatTooltip, MatIconButton, MatChipSet, MatChip, MatChipListbox, MatChipOption]
})
export class UsersRolesManagementComponent<T extends { roles: TRole[], user: Auth0User }, TRole> {
    @Input() users: T[] = [];
    @Input() availableRoles: TRole[] = [];
    @Input() canManagePermissions: boolean;
    @Input() loading: boolean;
    @Output() roleRemoved: EventEmitter<{ email: string, role: TRole }> = new EventEmitter<{ email: string; role: TRole }>();
    @Output() addUserRole: EventEmitter<{ user: T }> = new EventEmitter<any>();
    @Output() addUser: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }
}
